import { Button, Paper, Typography } from '@material-ui/core'

import { Auth } from 'aws-amplify'
import * as R from 'ramda'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import Loading from '../components/loading'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivder from '../containers/verticalGridDivider'
import { resetLoggingIn, signInRequest } from '../redux/auth/actions'
import { isLoggingInSelector } from '../redux/auth/selectors'

// import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types'

const Wrapper = styled.div`
  width: 100%;
  padding-top: 100px;
  display: flex;
  justify-content: center;
`

const LoginContainer = styled(Paper)`
  width: 500px;
  height: 350px;
  text-align: center;
  padding-top: 20px;
`

const SeparatingContainer = styled.div`
  margin: 20px 0px;
`

const ButtonContainer = styled.div`
  padding: 0 20%;
`

const Login = () => {
  const dispatch = useDispatch()
  const locationRedirectUrl = R.pathOr(
    '',
    ['state', 'redirectUrl'],
    useLocation()
  )
  const oAuthRedirectUrl = R.and(
    R.includes('code', locationRedirectUrl),
    R.includes('state', locationRedirectUrl)
  )
  const isLogginIn = useSelector(isLoggingInSelector) as boolean
  // const handleSignIn = () => {
  //   dispatch(signInRequest())
  //   void Auth.federatedSignIn({
  //     provider: CognitoHostedUIIdentityProvider.Google
  //   })
  // }

  const handleSignIn = () => {
    dispatch(signInRequest())
    void Auth.federatedSignIn({
      provider: 'Google' as any
    })
  }

  useEffect(() => {
    if (isLogginIn && !oAuthRedirectUrl) {
      dispatch(resetLoggingIn())
    }
  }, [])

  return (
    <VerticalGridDivder>
      <TopBar hidden={true} />
      <StyledMain>
        {isLogginIn ? (
          <Loading />
        ) : (
          <Wrapper>
            <LoginContainer>
              <SeparatingContainer>
                <img
                  alt="Fruit Supplier Logo"
                  src="/fruit-supplier-logo.png"
                  width="180px"
                  height="160px"
                />
              </SeparatingContainer>
              <SeparatingContainer>
                <Typography variant="subtitle2">
                  Fruit supplier Control Panel
                </Typography>
              </SeparatingContainer>
              <ButtonContainer>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  onClick={() => handleSignIn()}
                  fullWidth
                >
                  Sign In with Google
                </Button>
              </ButtonContainer>
            </LoginContainer>
          </Wrapper>
        )}
      </StyledMain>
    </VerticalGridDivder>
  )
}

export default Login
